import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import SideMenu from "./SideMenu";
import Sidebar from "./Sidebar";
import { useLocation } from "react-router-dom";
import MobileBottomNav from "./MobileBottomNav";
import "./AuthenticatedTheme.css";

function Layout({ subscriptionPlan, planLoaded }) {
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const location = useLocation();
  const isSuperRoute = location.pathname.startsWith("/superadmin");

  return (
    <div className="authenticated-app">
      <div className="md:h-16">
        <Header subscriptionPlan={subscriptionPlan} planLoaded={planLoaded} onOpenSubscriptionModal={() => setShowSubscriptionModal(true)} />
      </div>
      <div className="grid grid-cols-12 bg-gray-100 min-h-screen pb-16">
        <div className="col-span-2 h-screen sticky top-0 hidden lg:flex">
          {isSuperRoute ? (
            <Sidebar />
          ) : (
            <SideMenu subscriptionPlan={subscriptionPlan} planLoaded={planLoaded} onOpenSubscriptionModal={() => setShowSubscriptionModal(true)} />
          )}
        </div>
        <Outlet />
      </div>
      <MobileBottomNav />
    </div>
  );
}

export default Layout;
